import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './NotificationCenter.html?raw';
import NotificationPreviewRow from './NotificationPreviewRow';
import { NotificationTopics, NotificationTypes } from "./NotificationTypes";
import NotificationDisplay from './NotificationDisplay';
import FloatingContainer from '../../UI/Floating/FloatingContainer';
import { FeatureHelpers, ToasterHelpers, TranslationHelpers, UrlHelpers } from "../../../more/Helpers";
//import DataItems = require("DataItems");



interface NotificationListEntry {
    notificationData: NotificationTypes.NotificationEntity_Base;
    //node: HTMLElement;
    row: MdsLax<InstanceType<typeof NotificationPreviewRow>>;
    order: number;
}

interface LocalStorageSettings {
    userID: string;
    settings: Settings;
}
interface Settings {
    filterUnreadOnly: boolean;
    filterConfirmationOnly: boolean;
}

class NotificationCenter extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private btnMain: HTMLElement;
    private hiddenContainer: HTMLElement;
    private floatingContent: HTMLElement;
    private notificationEntryContainer: HTMLElement;
    private noEntriesNode: HTMLElement;
    private txtUnreadCount: HTMLSpanElement;
    private confirmationRemainingIconContainer: HTMLSpanElement;
    private btnToggleUnread: HTMLElement;
    private btnToggleConfirmation: HTMLElement;
    private btnSetAllRead: HTMLElement;
    private filterInfoLabel_UnreadOnly: HTMLElement;
    private filterInfoLabel_ConfirmationOnly: HTMLElement;

    private _notificationDisplay: MdsLax<InstanceType<typeof NotificationDisplay>>;
    private _floatingContainer: MdsLax<InstanceType<typeof FloatingContainer>>;

    private _notificationEntries: Array<NotificationListEntry>;

    
    //private showUnreadOnly: boolean = true;
    //private showConfirmationOnly: boolean = false;

    private currentSettings: Settings;

    
    protected _onNotificationsLoaded(list: Array<NotificationTypes.NotificationEntity_Base>): void {
       
        this.StandbyStop();

        if (FeatureHelpers.hasFeature("Notifications/AutomaticListener")) this.UiModder.domClass.remove(this.btnMain, "noCount");

        //console.log(this.id + " _onNotificationListenerLoaded", list);        


        let newList = [];
        // entry-Registry aufbauen
        
        for (let notification of list) {
            let entry = this.getEntryByNotificationId(notification.ID, true);
            if (entry) {
                entry.notificationData = notification;
            } else {
                entry = {
                    notificationData: notification,
                    row: null,
                    order: 0
                };
            }

            newList.push(entry);
        }
        
        this._updateEntryRegistry(newList);



        
    }

    private _onClick_FilterToggleUnread(evt: MouseEvent) {
        evt.stopPropagation();
        
        this.currentSettings.filterUnreadOnly = !this.currentSettings.filterUnreadOnly;

        this._updateLocalStorageSettings();

        this._drawNotificationRows();
    }
    private _onClick_FilterToggleConfirmationNeeded(evt: MouseEvent) {
        evt.stopPropagation();

        this.currentSettings.filterConfirmationOnly = !this.currentSettings.filterConfirmationOnly;
        this._drawNotificationRows();
    }
    private _onClick_SetAllRead(evt: MouseEvent) {
        evt.stopPropagation();

        let data = {
            notificationIDs: this._notificationEntries.map(entry => entry.notificationData?.ID)
        };

        this.RequestManager.callfunction(
            "Webtool_API_Notification__SetMultipleNotificationsRead",
            data,
            lang.hitch(this, this._onSetAllReadResponse),
            lang.hitch(this, this._onSetAllReadError)
        );
    }

    private _onSetAllReadResponse(response: Array<NotificationTypes.NotificationEntity_Base>) {
        //topic.publish(NotificationTopics.Updated_List, response);
        window.notificationListener.loadNotifications();
    }

    private _onSetAllReadError(error: more.requestErrorMessage) {
        if (this.hasUserRole("_DEV")) {
            ToasterHelpers.showToast({
                title: "DEV info: set all read failed",
                message: "Dieser Fehler wird nur für DEV angezeigt!\r\n" + error.Message,
                timeout: 12000,
                iconClass: toasterIcons.error
            });
        }
    }

    private _updateUnreadCount() {
        
        let unreadCount = this._notificationEntries.filter(entry => entry.notificationData.is_read != true).length;// this._listener.getUnreadNotifications().length;
        let unconfirmedCount = this._notificationEntries.filter(entry => entry.notificationData.is_confirmation_needed == true && entry.notificationData.is_confirmed != true).length;// this._listener.getUnconfirmedNotifications().length;
        let reminderCount = this._notificationEntries.filter(entry => entry.notificationData.type == "reminder" && entry.notificationData.is_read != true).length;

        this.txtUnreadCount.innerHTML = unreadCount.toString();
        this.txtUnreadCount.style.setProperty("--unreadCount", unreadCount.toString());
        this.txtUnreadCount.setAttribute("data-unread-count", unreadCount.toString());

        this.hideNode(this.confirmationRemainingIconContainer, unconfirmedCount == 0);

        this.UiModder.domClass.toggle(this.btnMain, "unread", unreadCount > 0);
        this.UiModder.domClass.toggle(this.btnMain, "unconfirmed", unconfirmedCount > 0);

        // einmal shaken lassen, falls Reminder offen oder unbestätigte Meldung. reicht wenn es ggf. bis zum nächsten Seitenwechsel bleibt
        this.UiModder.domClass.toggle(this.btnMain, "mds-shake", (reminderCount > 0 || unconfirmedCount > 0));
    }

    private _sortNotifications() {
        if (this._notificationEntries && this._notificationEntries.length >= 2) {
            this._notificationEntries.sort((a, b) => {
                let valueA, valueB;
                let valueNow = new Date().valueOf();
                //let valueA = (a.notificationData.date_expiration ? a.notificationData.date_expiration.valueOf() : 0);
                //let valueB = (b.notificationData.date_expiration ? b.notificationData.date_expiration.valueOf() : 0);

                // Sortierung nach Erinnerungsdatum: nur sinnvoll, wenn Erinnerungsdatum in der Verangenheit liegt!
                // außerdem sollen gelesene Erinnerungen auch wieder normal eingereiht werden
                valueA = (a.notificationData.alert_date ? a.notificationData.alert_date.valueOf() : 0);
                if (valueA > valueNow) valueA = 0;
                if (a.notificationData.is_read) valueA = 0;
                valueB = (b.notificationData.alert_date ? b.notificationData.alert_date.valueOf() : 0);
                if (valueB > valueNow) valueB = 0;
                if (b.notificationData.is_read) valueB = 0;

                if (valueA || valueB) return valueB - valueA;

                else {
                    valueA = (a.notificationData.date_notification ? a.notificationData.date_notification.valueOf() : 0);
                    valueB = (b.notificationData.date_notification ? b.notificationData.date_notification.valueOf() : 0);

                    return valueB - valueA;
                }

                return -1;
            });

            let index = 0;
            for (let entry of this._notificationEntries) {
                index++;
                entry.order = index;
            }
        }
    }

    private _drawNotificationRows(): void {

        this.UiModder.domClass.toggle(this.btnToggleUnread, "active", this.currentSettings.filterUnreadOnly);
        this.UiModder.domClass.toggle(this.btnToggleConfirmation, "active", this.currentSettings.filterConfirmationOnly);

        this.hideNode(this.filterInfoLabel_UnreadOnly, !this.currentSettings.filterUnreadOnly);
        this.hideNode(this.filterInfoLabel_ConfirmationOnly, !this.currentSettings.filterConfirmationOnly);

        for (let entry of this._notificationEntries) {
            this._drawNotification(entry);
        }

        this.hideNode(this.noEntriesNode, !!this._notificationEntries.length);
 
    }
    private _updateEntryRegistry(newList: Array<NotificationListEntry>): void {

        for (let entry of this._notificationEntries) {
            if (entry.row && !entry.row._destroyed) {
                entry.row.destroy();
                entry.row = null;
            }
        }

        this._notificationEntries = newList;

        this._sortNotifications();

        if (this._floatingContainer) this._drawNotificationRows();
        this._updateUnreadCount();        

    }

/**
* Einen Nachrichteneintrag in der Liste zeichnen oder, falls bereits als Node vorhanden, updaten.
*/
    private _drawNotification(notificationEntry: NotificationListEntry): void {
        //console.debug("NotificationCenter _drawNotification", notificationEntry);

        let row: MdsLax<InstanceType<typeof NotificationPreviewRow>> = null;
        if (notificationEntry.row == null || notificationEntry.row._destroyed) {
            row = new NotificationPreviewRow();
            this.UiModder.domConstruct.place(row.domNode, this.notificationEntryContainer);
            notificationEntry.row = row;
        }

        notificationEntry.row.applyData(notificationEntry.notificationData);
        notificationEntry.row.domNode.style.setProperty("order", notificationEntry.order as any);

        let isUnread = notificationEntry.notificationData.is_read != true;
        let isUnconfirmed = notificationEntry.notificationData.is_confirmation_needed == true && notificationEntry.notificationData.is_confirmed != true;
        let isConfirmationNeeded = notificationEntry.notificationData.is_confirmation_needed == true;



        let bShow = (this.currentSettings.filterConfirmationOnly && isConfirmationNeeded) || (this.currentSettings.filterUnreadOnly && isUnread);
        bShow = bShow || (!this.currentSettings.filterConfirmationOnly && !this.currentSettings.filterUnreadOnly);

        // anzeigen: IMMER wenn ungelesen oder nicht bestätigt
        if (isUnread || isUnconfirmed) {
            bShow = true;
        }

        // einschränken: auf Bestätigungen reduzieren
        if (!isConfirmationNeeded && this.currentSettings.filterConfirmationOnly) {
            bShow = false;
        }

        // einschränken: wenn unread und confirmation, dann nur falls unconfirmed
        if (this.currentSettings.filterConfirmationOnly && this.currentSettings.filterUnreadOnly) {
            bShow = bShow && isUnconfirmed;
        }

        this.hideNode(notificationEntry.row.domNode, !bShow);
    }

    addNotification(notificationData: NotificationTypes.NotificationEntity_Base, draw?: boolean): NotificationListEntry {

        let entry: NotificationListEntry = this.getEntryByNotificationId(notificationData.ID);

        if (entry == null) {
            entry = {
                notificationData: notificationData,
                row: null,
                order:0
            };
        }

        this._notificationEntries.push(entry);

        this._sortNotifications();

        if (entry.row == null && draw === true) {
            this._drawNotification(entry);
        }

        return entry;
    }

    removeNotificationEntry(notification: NotificationListEntry): boolean {
        if (notification == null) return false;

        let entry = this.getEntryByNotificationId(notification.notificationData.ID);
    }

    private getEntryByNotificationId(notificationID: string, removeFromArray?: boolean): NotificationListEntry {
        for (var i = 0; i < this._notificationEntries.length; i++) {
            if (this._notificationEntries[i].notificationData.ID == notificationID || this._notificationEntries[i].notificationData.ID == notificationID) {
                let entry = this._notificationEntries[i];
                if (removeFromArray === true) this._notificationEntries.splice(i, 1);
                return entry;
            }
        }

        return null;
    }

    showNotification(notificationOrId: string | NotificationListEntry): void {


        let notification: NotificationListEntry;
        if (typeof (notificationOrId) == "string") {
            notification = this.getEntryByNotificationId(notificationOrId);



        } else {
            notification = notificationOrId;
        }

        if (!notificationOrId) {
            return;
        }

        this.closeList();

        if (this._notificationDisplay == null) {
            let dsp = new NotificationDisplay();
            if (notification) {
                dsp.setup(notification.notificationData);
            } else {
                dsp.setup(notificationOrId as string);
            }

        }

        //this._notificationDisplay.setNotification(notification.notificationData, true);
    }

    

    private _onClick_Main(evt: MouseEvent) {
        evt.stopPropagation();
        if (!this._floatingContainer) {
            this.openList();
            
        } else {
            this.closeList();
        }
    }

    openList() {
        if (!this._floatingContainer) {



            let container = new FloatingContainer();
            container.open(this.domNode, null, false, true, null, 44);

            this._floatingContainer = container;
            this._floatingContainer.setNewContent(this.floatingContent);

            this._drawNotificationRows();

            container.on("close", lang.hitch(this, this._onClosedFloatingCenter));

            this.UiModder.domClass.add(this.btnMain, "open");


            // wenn der automatische Listener nicht läuft, dann bei jedem Öffnen laden!
            if (!FeatureHelpers.hasFeature("Notifications/AutomaticListener") && window.notificationListener) {
                window.notificationListener.getNotifications();
                this.StandbyStart(this.notificationEntryContainer);
            }
        }
    }

    private _onClosedFloatingCenter() {
        
        this.UiModder.domConstruct.place(this.floatingContent, this.hiddenContainer);
        try {
            this._floatingContainer.destroy();
            
        } catch (ex) {

        }
        this._floatingContainer = null;

        this.UiModder.domClass.remove(this.btnMain, "primaryBG open");

    }

    closeList() {
        if (this._floatingContainer) {
            this._floatingContainer.close();
        }
    }

    private _onRequestNotificationAction(action: NotificationTypes.UpdateAction, notificationOrID: string | NotificationTypes.NotificationEntity_Base, count?: number) {
        
        let entry: NotificationListEntry = null;
        if (typeof (notificationOrID) == "string") {
            entry = this.getEntryByNotificationId(notificationOrID);
        } else if (notificationOrID) {
            entry = this.getEntryByNotificationId(notificationOrID.ID); 
        }

        if (!entry) return;

        let data: any = {
            notificationID: entry.notificationData.ID,
        }

        switch (action) {
            case "confirmed": data.setConfirm = true;
                break;
            case "unconfirmed": data.setConfirm = false;
                break;
            case "read": data.setRead = true;
                break;
            case "unread": data.setRead = false
                break;

            default: return;
        }

        if (!count) count = 0;


        this.RequestManager.callfunction(
            "Webtool_API_Notification__UpdateNotification",
            data,
            lang.hitch(this, this._onNotificationActionResponse, entry, action),
            lang.hitch(this, this._onNotificationActionError, entry.notificationData.ID, action, count++)
        );
    }

    private _onNotificationActionError(notificationID: string, action: NotificationTypes.UpdateAction, tryCount: number, error: more.requestErrorMessage) {
        if (tryCount > 5) return;

        setTimeout(lang.hitch(this, this._onRequestNotificationAction, action, notificationID, tryCount), 10000);

        if (this.hasUserRole("_DEV")) {
            ToasterHelpers.showToast({
                title: "notification action failed: " + action + " - trying again soon...",
                message: "Dieser Fehler wird nur für DEV angezeigt!\r\n" + error.Message,
                ID: "actionfail-" + notificationID,
                timeout: 12000
            });
        }
    }
    private _onNotificationActionResponse(entry: NotificationListEntry, action: NotificationTypes.UpdateAction, response: NotificationTypes.NotificationEntity_Base) {
        if (!response || !entry) return;

        ToasterHelpers.removeToast("actionfail-" + entry.notificationData.ID)

        entry.notificationData = response;
        this._drawNotification(entry);

        switch (action) {
            case "confirmed":
                ToasterHelpers.showToast({
                    title: "Notifications__ActionResult_Confirmed",
                    iconClass: toasterIcons.confirmCheck,
                });
                break;
            case "unconfirmed":
                break;
            case "read": 
                break;
            case "unread": 
                break;

            default: return;
        }

        topic.publish(NotificationTopics.Updated_Single + entry.notificationData.ID, response);
        topic.publish(NotificationTopics.Updated_Single, entry.notificationData);


        this._updateUnreadCount();;
    }

    private _updateLocalStorageSettings() {

        try {
            let settingsStr = localStorage.getItem("ego_NotificationCenter_Settings");
            let settingsArray: Array<LocalStorageSettings>
            if (settingsStr) {
                settingsArray = JSON.parse(settingsStr);
            } else {
                settingsArray = [];
            }

            if (settingsArray) {
                for (let userSetting of settingsArray) {
                    if (userSetting.userID == this.getCurrentUserId(null, true)) {
                        userSetting.settings = this.currentSettings;

                        localStorage.setItem("ego_NotificationCenter_Settings", JSON.stringify(settingsArray));
                        return;
                    }
                }

                settingsArray.push({
                    userID: this.getCurrentUserId(null, true),
                    settings: this.currentSettings
                })
                localStorage.setItem("ego_NotificationCenter_Settings", JSON.stringify(settingsArray));
            }
        } catch (ex) {

        }
    }

    private _onSessionChange() {
        if (!window.sessionInfo?.isSessionOpen()) return;

        try {
            let settingsStr = localStorage.getItem("ego_NotificationCenter_Settings");
            if (settingsStr) {
                let settingsArray: Array<LocalStorageSettings> = JSON.parse(settingsStr);
                for (let userSetting of settingsArray) {
                    if (userSetting.userID == this.getCurrentUserId(null, true)) {
                        this.currentSettings = userSetting.settings;
                    //    this.showConfirmationOnly = this.currentSettings.filterConfirmationOnly;
                    //    this.showUnreadOnly = this.currentSettings.filterUnreadOnly;
                    }
                }
            }
        } catch (ex) {

        }

        let openID = UrlHelpers.getUrlParameterValue("openNotification");
        if (openID) {
            console.debug("openNotification", openID);
            UrlHelpers.removeUrlParameter("openNotification");
            setTimeout(lang.hitch(this, this.showNotification, openID), 1000);
        }

    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this._notificationEntries = [];

        this.currentSettings = {
            filterConfirmationOnly: false,
            filterUnreadOnly: false
        };
       
        this.addSubscription(NotificationTopics.Loaded, lang.hitch(this, this._onNotificationsLoaded));
        this.addSubscription(NotificationTopics.SetRead, lang.hitch(this, this._onRequestNotificationAction, "read"));
        this.addSubscription(NotificationTopics.SetUnread, lang.hitch(this, this._onRequestNotificationAction, "unread"));
        this.addSubscription(NotificationTopics.SetConfirmed, lang.hitch(this, this._onRequestNotificationAction, "confirmed"));
        //this.addSubscription(NotificationTopics.Updated_List, lang.hitch(this, this._onNotificationsLoaded));
        //this.addSubscription("/Notifications/Updated", lang.hitch(this, this._onNotificationsUpdated));

        this.addSubscription("/Session/CheckForExistingSession", lang.hitch(this, this._onSessionChange));

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(NotificationCenter);